var booleanValidate = require('shared').booleanValidate,
    emptyValidator = require('./emptyValidator'),
    validateDateTime = require('./dateTimeValidator');

var validator = booleanValidate.or(emptyValidator, validateDateTime);
validator.message = 'Invalid date or time';

module.exports = validator;
